import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import CompanyService from "../../../../services/catalogs/CompanyService";

export const REQUEST_DELETE_COMPANY = "REQUEST_DELETE_COMPANY";
export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS";
export const DELETE_COMPANY_ERROR = "DELETE_COMPANY_ERROR";

function requestDeleteCompany() {
  return {
    type: REQUEST_DELETE_COMPANY,
  };
}

function deleteCompanySuccess(json) {
  return {
    type: DELETE_COMPANY_SUCCESS,
    message: json.data,
  };
}

function deleteCompanyError(json) {
  return {
    type: DELETE_COMPANY_ERROR,
    error: json.data,
  };
}

export function deleteCompany(company_id) {
  return (dispatch) => {
    dispatch(requestDeleteCompany());
    return CompanyService.deleteCompany(company_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(deleteCompanySuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(deleteCompany(company_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(deleteCompanyError(json.data));
      }
    });
  };
}
